module.exports = __webpack_public_path__ + "img/suggestion.e76f8531.png";